module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-top-571a4b6335af379a475321ee05edb9d6.svg";